import { useState, useEffect, useContext } from "react";
import styles from "./styles.module.css";
import ShiftNavbar from "components/utils/ShiftNavBar/ShiftNavBar";
import ShiftReport from "../Report/ShiftReport";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaleSummary from "../Report/SaleSummary";
import ItemSummaryReport from "../Report/ItemSummary";
import ItemisedBillSummaryReport from "../Report/ItemisedBill";
import EstimateBillSummaryReport from "../Report/EstimateBill";
import CategorySalesReport from "../Report/CategorySalesReport";
import { STORAGE_KEYS, STAFF_PERMISSION } from "const";
import ShopContext from "context/ShopContext";
import { usePermission } from "hooks/usePermission";

function SalesReports() {
  const { selectedShop } = useContext(ShopContext);
  const requiredCode = selectedShop?.config?.staff_access_codes?.report;
  const { checkPermissionAndExecute, PermissionDialog } = usePermission();

  const [selected, setSelected] = useState("shiftReport");
  const [reportShiftId, setReportShiftId] = useState(localStorage.getItem(STORAGE_KEYS.SHIFT_ID));
  const [isAuthorized, setIsAuthorized] = useState(!requiredCode);
  const [activeView, setActiveView] = useState(requiredCode ? "content" : "menu");

  useEffect(() => {
    if (!requiredCode) {
      setIsAuthorized(true);
    }
  }, [requiredCode]);

  useEffect(() => {
    if (isAuthorized && window.innerWidth <= 768) {
      setActiveView("menu");
    }
  }, [isAuthorized]);

  const handleUnlockClick = () => {
    checkPermissionAndExecute(STAFF_PERMISSION.REPORT, () => setIsAuthorized(true), "Report Access");
  };

  useEffect(() => {
    if (!isAuthorized && requiredCode) {
      handleUnlockClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShiftChange = (newShiftId) => {
    setReportShiftId(newShiftId);
  };

  const renderContent = () => {
    if (!isAuthorized) {
      return (
        <div className={styles.authContainer}>
          <PermissionDialog />
          <div className={styles.authCard}>
            <h2>Report Access Locked</h2>
            <p>You need permission to view reports.</p>
            <button className={styles.unlockButton} onClick={handleUnlockClick}>
              Unlock Reports
            </button>
          </div>
        </div>
      );
    }

    switch (selected) {
      case "itemSummary":
        return <ItemSummaryReport key={reportShiftId} shiftId={reportShiftId} />;
      case "salesSummary":
        return <SaleSummary key={reportShiftId} shiftId={reportShiftId} />;
      case "itemisedSales":
        return <ItemisedBillSummaryReport key={reportShiftId} shiftId={reportShiftId} />;
      case "estimates":
        return <EstimateBillSummaryReport key={reportShiftId} shiftId={reportShiftId} />;
      case "categorySales":
        return <CategorySalesReport key={reportShiftId} shiftId={reportShiftId} />;
      default:
        return <ShiftReport shiftId={reportShiftId} />;
    }
  };

  return (
    <div className={`${styles.container} ${activeView === "content" ? styles.contentMode : styles.menuMode}`}>
      <div className={styles.sidebarWrapper}>
        <ShiftNavbar
          selected={selected}
          onSelect={(tabKey) => {
            setSelected(tabKey);
            setActiveView("content");
          }}
          onShiftChange={handleShiftChange}
          selectedShiftId={reportShiftId}
        />
      </div>
      <div className={styles.content}>
        {activeView === "content" && isAuthorized && (
          <div className={styles.mobileBackHeader} onClick={() => setActiveView("menu")}>
            <ArrowBackIcon className={styles.backIcon} />
            <span>Back to Reports Menu</span>
          </div>
        )}
        {renderContent()}
      </div>
    </div>
  );
}

export default SalesReports;
